export enum ProfileFields {
    BIO = 'bio',
    COMPANY = 'company',
    JOB_TITLE = 'jobTitle',
    SCHOOL = 'school',
    DATE_DESCRIPTION = 'datePreferences.description'
}